import React from 'react';
import queryString from 'query-string';
import { Form } from 'reactstrap';
import { CSSTransition } from 'react-transition-group';

import { WithLocalize } from "../../containers/I18nProvider";
import { WithCaptcha } from '../../containers/captcha';

/**
 * Login Form Container
 *
 * @class LoginForm
 * @extends {React.Component}
 */
class LoginForm extends React.Component {

  constructor(props, context) {
    super(props, context);

    this.parameters = queryString.parse(props.location.search);
    this.parameters.idp = 'gig';
    this.ref = React.createRef();
    this.state = {
      onLogin: false,
      showForm: false,
      error: {
        open: false,
        message: ''
      },
      username: '',
      password: ''
    };
  }

  componentDidMount() {

    this.setState({ showForm: true });
  }

  onError(error) {
    this.setState({
      error: {
        open: true,
        message: error.message
      }
    });
  }

  async onSubmit(ev) {
    ev.preventDefault();

    this.setState({
      onLogin: true,
      error: {
        open: false,
        message: ''
      }
    });



    this.props.api.userPassLogin(
      {
        username: this.usernameInput.value,
        password: this.passwordInput.value
      }, this.parameters

    )
      .then((response) => {
        this.setState({ onLogin: false });
        window.location = this.parameters.redirect_uri + '?' + queryString.stringify(response);
      })
      .catch(error => {
        const translate = this.props.translate(error.errorCode);

        let message = 'Usuário o contraseña invalido';

        if (translate) {
          message = translate;
        } else if (error.details) {
          message = error.details;
        }

        this.setState({ onLogin: false, error: { open: true, message: message } });
      });
  }

  render() {
    const { translate } = this.props;

    return (
      <CSSTransition
        in={this.state.showForm}
        timeout={300}
        classNames="formshow"
        nodeRef={this.ref}
        unmountOnExit
      >
        <div ref={this.ref}>
          <Form onSubmit={event => this.onSubmit(event)} className='gig-form'>
            <label className='label-gig'>Correo Electrónico
              <input
                className='input-gig'
                disabled={this.state.onLogin}
                ref={(ref) => {
                  this.usernameInput = ref;
                }
                }
                required={true}
                tabIndex={1}
                type="text"
                autoCorrect="off"
                autoCapitalize="none"
                name="username"
              />
            </label>
            <label className='label-gig'>Contraseña
              <input
                className='input-gig'
                required={true}
                disabled={this.state.onLogin}
                ref={(ref) => {
                  this.passwordInput = ref;
                }
                }
                tabIndex={1}
                type="password"
                autoCorrect="off"
                autoCapitalize="none"
                name="password"
              />
            </label>
            <div className="gig-buttons">
              <a className='gig-a' href="https://gigacable.com.mx/#/recuperar">¿Olvidaste tu contraseña?</a>
              <a className='gig-a-2' href="https://gigacable.com.mx/#/recuperar">¿Olvidaste tu <br /> contraseña?</a>
              <button
                className='gig-button'
                block={!this.parameters.failureRedirect}
                tabIndex={1}
                type="submit"
                name="submit"
              >
                {translate('Ingresar')}
              </button>
            </div>
            <div className='gig-footer'>
              <div>¿No tienes una cuenta?</div>
              <a style={{ color: '#039be5' }} href="https://gigacable.com.mx/#/registro">Crear Cuenta</a
              >
            </div>
            <div className='gig-error-container'>
              <strong className='gig-error-msg'>{this.state.error.message} </strong>
            </div>
            <this.props.TurnstileComponent setTurnstileSuccess={this.props.setTurnstileSuccess} />
          </Form>
        </div>
      </CSSTransition>
    );
  }
}

export default WithCaptcha(WithLocalize(LoginForm), { useInsideForm: true, style: { marginTop: '2rem' } });
